import React from 'react';
import SEO from '../components/SEO/SEO';

const PrivacyPolicyPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="プライバシーポリシー"
        description="SrWith株式会社のプライバシーポリシー。労務管理プラットフォームにおける個人情報の取扱いについて定めています。"
        noindex={true}
      />

      {/* ヘッダーセクション */}
      <div className="bg-pink-beige py-16 md:py-24">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <h1 className="text-3xl md:text-4xl font-bold text-white text-center">
            プライバシーポリシー
          </h1>
        </div>
      </div>

      {/* コンテンツ */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-12 md:py-16">
        <p className="text-gray-text text-sm mb-8">最終改定日：2026年1月6日</p>

        <div className="prose prose-lg max-w-none text-gray-text leading-relaxed">
          <p className="mb-8">
            SrWith（以下「当社」）は、労務管理および業務支援に関するサービスを提供するにあたり、個人情報の重要性を十分に認識し、個人情報の保護に関する法令および関連ガイドラインを遵守するとともに、以下のとおりプライバシーポリシー（以下「本ポリシー」）を定め、個人情報の適切な取扱いと保護に努めます。
          </p>

          {/* 1. 適用範囲 */}
          <section className="mb-10">
            <h2 className="text-xl md:text-2xl font-bold text-brown mb-4">1．適用範囲</h2>
            <p>
              本ポリシーは、当社が提供する労務DXプラットフォーム「SrWith」およびこれに付随する各種サービス（以下「本サービス」）において、当社が取得・利用・管理する個人情報の取扱いについて定めるものです。
            </p>
          </section>

          {/* 2. 取得する情報の種類 */}
          <section className="mb-10">
            <h2 className="text-xl md:text-2xl font-bold text-brown mb-4">2．取得する情報の種類</h2>
            <p className="mb-4">当社は、本サービスの提供にあたり、以下の情報を取得する場合があります。</p>

            <h3 className="text-lg font-semibold text-brown mt-6 mb-3">（1）利用企業・管理者に関する情報</h3>
            <ul className="list-disc pl-6 space-y-1">
              <li>氏名、会社名、部署名、役職</li>
              <li>メールアドレス、電話番号</li>
              <li>アカウント情報（ID、パスワード等）</li>
            </ul>

            <h3 className="text-lg font-semibold text-brown mt-6 mb-3">（2）利用企業の従業員等に関する情報</h3>
            <ul className="list-disc pl-6 space-y-1">
              <li>氏名、社員番号等の識別情報</li>
              <li>勤怠情報、労務管理に関する情報</li>
              <li>本サービス上で管理される業務関連情報</li>
            </ul>
            <p className="mt-3 text-sm">
              ※当社は、マイナンバー等の特定個人情報については、法令に基づく場合を除き、原則として取り扱いません。
            </p>

            <h3 className="text-lg font-semibold text-brown mt-6 mb-3">（3）労務関連書類に含まれる情報</h3>
            <p className="mb-3">当社は、本サービスを通じて、利用企業が作成・管理する以下の労務関連書類に含まれる情報を取り扱う場合があります。</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>就業規則および関連規程</li>
              <li>時間外・休日労働に関する協定（36協定）</li>
              <li>労働条件通知書、雇用契約書</li>
              <li>賃金、手当、労働時間等の労働条件に関する情報</li>
            </ul>
            <p className="mt-3">これらの情報は、利用企業の指示および責任のもと、本サービスの提供目的の範囲内で取り扱われます。</p>
            <p className="mt-2 text-sm">※当社は、これらの書類の内容について、法令適合性や個別の労務判断を保証するものではありません。</p>

            <h3 className="text-lg font-semibold text-brown mt-6 mb-3">（4）社労士・パートナー等に関する情報</h3>
            <ul className="list-disc pl-6 space-y-1">
              <li>氏名、所属、連絡先</li>
              <li>サービス利用に必要な認証情報</li>
            </ul>

            <h3 className="text-lg font-semibold text-brown mt-6 mb-3">（5）サービス利用に伴い自動的に取得される情報</h3>
            <ul className="list-disc pl-6 space-y-1">
              <li>アクセスログ、操作履歴</li>
              <li>IPアドレス、ブラウザ情報</li>
              <li>Cookieおよび類似技術による情報</li>
            </ul>
          </section>

          {/* 3. 個人情報の利用目的 */}
          <section className="mb-10">
            <h2 className="text-xl md:text-2xl font-bold text-brown mb-4">3．個人情報の利用目的</h2>
            <p className="mb-4">当社は、取得した個人情報を以下の目的の範囲内で利用します。</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>本サービスの提供、運用、保守</li>
              <li>ユーザー認証および本人確認</li>
              <li>利用に関する連絡、通知、問い合わせ対応</li>
              <li>サービス改善、機能開発、利用状況分析</li>
              <li>セミナー・イベント等の案内</li>
              <li>不正利用防止およびセキュリティ確保</li>
              <li>法令に基づく対応</li>
            </ul>
          </section>

          {/* 4. 個人情報の管理責任と役割分担 */}
          <section className="mb-10">
            <h2 className="text-xl md:text-2xl font-bold text-brown mb-4">4．個人情報の管理責任と役割分担</h2>
            <ul className="list-disc pl-6 space-y-3">
              <li>本サービスに入力・登録される情報の内容の正確性については、原則として利用企業の責任において管理されるものとします。</li>
              <li>当社は、本サービスを提供する立場として、当該情報を適切に管理し、漏えい等の防止に努めます。</li>
              <li>社会保険労務士その他の第三者が本サービスを通じて関与する場合においても、各当事者はそれぞれの法的責任の範囲内で個人情報を取り扱うものとします。</li>
              <li>労務関連書類（就業規則、36協定、労働条件通知書等）の作成、内容の適法性および最新性については、原則として利用企業の責任において管理されるものとします。</li>
            </ul>
          </section>

          {/* 5. 第三者提供 */}
          <section className="mb-10">
            <h2 className="text-xl md:text-2xl font-bold text-brown mb-4">5．第三者提供</h2>
            <p className="mb-4">当社は、次の場合を除き、個人情報を第三者に提供しません。</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>本人の同意がある場合</li>
              <li>法令に基づく場合</li>
              <li>人の生命・身体・財産の保護のために必要な場合</li>
              <li>業務委託先に必要な範囲で提供する場合</li>
            </ul>
          </section>

          {/* 6. 業務委託 */}
          <section className="mb-10">
            <h2 className="text-xl md:text-2xl font-bold text-brown mb-4">6．業務委託</h2>
            <p>
              当社は、本サービスの提供に必要な範囲で、個人情報の取扱いを外部事業者に委託する場合があります。この場合、適切な委託先を選定し、契約および監督を通じて安全管理を行います。
            </p>
          </section>

          {/* 7. 外部サービスとの連携 */}
          <section className="mb-10">
            <h2 className="text-xl md:text-2xl font-bold text-brown mb-4">7．外部サービスとの連携（API連携等）</h2>
            <p className="mb-4">当社は、本サービスの利便性向上および機能拡張のため、将来、外部サービスとのAPI連携その他の技術的連携（以下「外部連携」）を実施する場合があります。</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>外部連携は、利用企業またはユーザーが当該連携を明示的に有効化した場合にのみ実施されます。</li>
              <li>外部連携により取り扱う情報は、連携先サービスの利用に必要な範囲に限定されます。</li>
              <li>外部連携先における個人情報の取扱いについては、当該事業者が定めるプライバシーポリシー等が適用されます。</li>
              <li>将来、外部連携先が日本国外に所在する事業者となる場合があります。その場合、当社は法令に基づき必要な措置を講じます。</li>
            </ul>
          </section>

          {/* 8. Cookie等の利用 */}
          <section className="mb-10">
            <h2 className="text-xl md:text-2xl font-bold text-brown mb-4">8．Cookie等の利用</h2>
            <p>
              当社は、本サービスおよびWebサイトの利便性向上、利用状況分析のため、Cookieおよび類似技術を使用することがあります。これらにより取得される情報は、個人を特定する目的では利用しません。
            </p>
          </section>

          {/* 9. 安全管理措置 */}
          <section className="mb-10">
            <h2 className="text-xl md:text-2xl font-bold text-brown mb-4">9．安全管理措置</h2>
            <p>
              当社は、個人情報への不正アクセス、漏えい、滅失または毀損の防止のため、組織的・技術的・物理的な安全管理措置を講じます。
            </p>
          </section>

          {/* 10. サービス終了・解約時の取扱い */}
          <section className="mb-10">
            <h2 className="text-xl md:text-2xl font-bold text-brown mb-4">10．サービス終了・解約時の取扱い</h2>
            <p>
              本サービスの利用終了後、当社は、法令および契約内容に従い、個人情報を適切に削除または匿名化します。
            </p>
          </section>

          {/* 11. 法令遵守および見直し */}
          <section className="mb-10">
            <h2 className="text-xl md:text-2xl font-bold text-brown mb-4">11．法令遵守および見直し</h2>
            <p>
              当社は、個人情報保護に関する法令および社会的要請の変化に応じて、本ポリシーの内容を適宜見直し、改善を行います。
            </p>
          </section>

          {/* 12. お問い合わせ窓口 */}
          <section className="mb-10">
            <h2 className="text-xl md:text-2xl font-bold text-brown mb-4">12．お問い合わせ窓口</h2>
            <p className="mb-4">個人情報の取扱いに関するお問い合わせは、以下までご連絡ください。</p>
            <div className="bg-gray-50 p-6 rounded-xl">
              <p className="font-semibold text-brown">SrWith株式会社</p>
              <p>佐賀県唐津市和多田海士町5-14</p>
              <p>代表取締役　塚本　祥太郎</p>
              <p className="mt-4">お問い合わせは、当社公式Webサイトの お問い合わせフォームよりお願いします。</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
